import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {PhoneNumber} from '../../../types/PhoneNumber';
import {DataLayerParamsClickGA4} from '../../../types/DataLayerParamsClickGA4';
import {BookingSettings} from '../../../types/BookingSettings';
import {CareproviderUnitType} from '../../../types/CareproviderUnitType';
import {DLPageTypeEnum} from '../../../enums/DataLayerEnums';

@Component({
  selector: 'app-cpru-contact',
  templateUrl: './cpru-contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruContactComponent {
  protected phoneNumbers = input<PhoneNumber[]>(null);
  protected websiteUrl = input<string>(null);
  protected featureLabel = input<string>(null);
  protected bookingSettings = input<BookingSettings[]>(null);
  protected mainCaregiverUnitType = input<CareproviderUnitType>(null);
  protected id = input<number>(null);

  public customGa4Params = computed<DataLayerParamsClickGA4>(() =>
    this.buildDataLayerParamsClickGa4(this.bookingSettings(), this.mainCaregiverUnitType(), this.id()),
  );

  private buildDataLayerParamsClickGa4(
    bookingSettings: BookingSettings[],
    mainCaregiverUnitType: CareproviderUnitType,
    id: number,
  ): DataLayerParamsClickGA4 {
    return {
      callToAction: 'kundweb - kundens webbsida',
      bookingType: bookingSettings && bookingSettings.length > 0 ? bookingSettings[0].bookingType?.name : null,
      inferredCareProviderTypeAreaId: mainCaregiverUnitType?.area?.id,
      mainCareProviderTypeId: mainCaregiverUnitType?.id,
      inferredCategoryTypeId: mainCaregiverUnitType?.id,
      cpruId: id,
      pageType: DLPageTypeEnum.CARE_SERVICE_PAGE,
    };
  }
}
